module.exports = __webpack_public_path__ + "img/corp-features-wellness.a855109f.svg";